export const defaultConfig = Object.freeze({
  shop_id: process.env.REACT_APP_SHOP_ID,
  shop_code: process.env.REACT_APP_SHOP_CODE,
  api_base_url: process.env.REACT_APP_API_BASE_URL,
});

let activeConfig = null;
export const readSession = (key) => {
  try { return sessionStorage.getItem(key); } catch { return null; }
};
export const writeSession = (key, value) => {
  try {
    if (value == null) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, value);
  } catch { /* Booking can still work when persistence is disabled. */ }
};
export const activateConfig = (config) => {
  if (!config.shop_id || !config.shop_code || !config.api_base_url) {
    throw new Error('The shop ID, shop code, and API URL must be configured.');
  }
  activeConfig = Object.freeze({ ...config });
  writeSession('shop_id', String(config.shop_id));
  writeSession('shop_code', config.shop_code);
};
export const getShopId = () => activeConfig?.shop_id || readSession('shop_id') || defaultConfig.shop_id;
export const getShopCode = () => activeConfig?.shop_code || readSession('shop_code') || defaultConfig.shop_code;
// Browser storage must not redirect booking data to a substituted API origin.
export const getApiBaseUrl = () => defaultConfig.api_base_url;
export const getConfig = () => ({ shop_id: getShopId(), shop_code: getShopCode(), api_base_url: getApiBaseUrl() });
